import { CommerceApiHttpService } from '../../common/types';
import { SearchFilterExperienceApi } from '../../models/search-filter/search-filter.api';
import { SearchFilter } from '../../models/search-filter/types';

export class OcbSearchFilterExperienceApi implements SearchFilterExperienceApi {
  constructor(private http: CommerceApiHttpService) {}

  public getFilters(): Promise<SearchFilter> {
    throw new Error('Method not implemented.');
  }
}
